import { render, staticRenderFns } from "./CustomerOrdersModal.vue?vue&type=template&id=11f9832c&scoped=true"
import script from "./CustomerOrdersModal.vue?vue&type=script&lang=js"
export * from "./CustomerOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrdersModal.vue?vue&type=style&index=0&id=11f9832c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f9832c",
  null
  
)

export default component.exports